import type { Subaccount, SubaccountTenantRole } from './types';

/**
 * Which tenant the client's tokens are scoped to.
 *  - home: the caller's own session (agency staff view)
 *  - subaccount: tokens issued by POST /agencies/:id/subaccounts/:tenantId/switch,
 *    whose `tid` is the sub-account, so tenant-scoped routes act inside it.
 */
export type SessionScope =
  | { kind: 'home' }
  | { kind: 'subaccount'; agencyId: string; subaccount: Subaccount; role: SubaccountTenantRole };

export const HOME_SCOPE: SessionScope = { kind: 'home' };

/** A stable key that changes whenever the scope changes; use it to re-fetch scoped data. */
export function scopeKey(scope: SessionScope): string {
  return scope.kind === 'home' ? 'home' : `subaccount:${scope.agencyId}:${scope.subaccount.id}`;
}
